import React, { useState } from 'react';
import { AppCard, AppModal, AppRemixIcon } from '@/layout/AppComponents';
import styled from 'styled-components';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../../../constants/colors';
import CalendarNewEventForm from '../../ExpandedTabs/Calendar/CalendarNewEventForm';
import Translator from '../../../../../../components/helpers/Translator';

const ChangeBlockCalendar = (props) => {
  const { handleAddCalendarEvent, value } = props;
  const [showNewCalendarModal, setShowNewCalendarModal] = useState(false);
  return (
    <>
      <span
        className={`btn btn-block btn-sm btn-outline-light mb-2 ${value === null ? '' : 'disabled'}`}
        onClick={() => (value === null ? setShowNewCalendarModal(true) : undefined)}
      >
        <Translator file="module-legalCompliance" name="create.calendar.event" />
      </span>
      {value === null
        ? <small><Translator file="module-legalCompliance" name="create.model.calendar.event.selected.obligations" /></small>

        : (
          <AppCard>
            <CalendarElement>
              <span>{value.date}</span>
              <AppRemixIcon
                icon="delete-bin"
                color={colors.danger}
                onClick={() => handleAddCalendarEvent(null)}
                title={ReactDOMServer.renderToString(<Translator file="user" name="user.remove" />)}
                className="pointer"
              />
            </CalendarElement>

          </AppCard>
        )}

      <AppModal
        show={showNewCalendarModal}
        title={ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="create.event.calendar.template" />)}
        onClose={() => setShowNewCalendarModal(false)}
        size="lg"
      >
        <CalendarNewEventForm
          plantObligationID={null}
          handleAddCalendarDate={(v) => { handleAddCalendarEvent(v); setShowNewCalendarModal(false); }}
          isExternal
        />
      </AppModal>
    </>
  );
};
export default ChangeBlockCalendar;

const CalendarElement = styled.div`
  display: grid;
  grid-template-columns: 1fr 20px;
`;
